// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallMissed24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.07812 10.4749L11.4695 15.8663C11.6166 16.0133 11.8095 16.0865 12.0022 16.0859C12.1934 16.0854 12.3845 16.0122 12.5304 15.8663L19.2021 9.19452C19.495 8.90163 19.495 8.42676 19.2021 8.13386C18.9092 7.84097 18.4344 7.84097 18.1415 8.13386L12 14.2754L7.13991 9.41531L10.046 9.41531C10.4602 9.41531 10.796 9.07953 10.796 8.66531C10.796 8.2511 10.4602 7.91531 10.046 7.91531L5.36923 7.91531C5.16383 7.90411 4.9547 7.97696 4.79779 8.13386C4.6512 8.28046 4.57797 8.47265 4.57812 8.66479C4.57812 8.66497 4.57812 8.66514 4.57812 8.66531L4.57813 13.3832C4.57813 13.7974 4.91391 14.1332 5.32812 14.1332C5.74234 14.1332 6.07813 13.7974 6.07813 13.3832L6.07812 10.4749Z"
				/>
			</Svg>
		);
	}
);
SvgCallMissed24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallMissed24;
